import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Container,
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  FreemiumIcon,
  InfoIcon,
  PlusIcon,
  PopularStar,
} from "../../../assets/icons/Icons";
import EastIcon from "@mui/icons-material/East";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ReactComponent as SchoolPaymentIcon } from "../../../assets/images/SchoolPaymentIcon.svg";
import { ReactComponent as TotalIcon } from "../../../assets/images/TotalIcon.svg";
import { ReactComponent as UpArrowIcon } from "../../../assets/images/UpArrow.svg";
import { ReactComponent as DownArrowIcon } from "../../../assets/images/DownArrow.svg";
import { Link, useParams } from "react-router-dom";
import useUser from "../../../hooks/useUser";
import { useDispatch } from "react-redux";
import useSettings from "../../../hooks/useSettings";
import moment from "moment";
import BusyOverlay from "../../../components/OverLay/BusyOverLay";
import { PerformaceTable } from "./performaceTable";
import useSubscription from "../../../hooks/useSubscription";
import { fetchStudyExamByProfileId, fetchSubjectsAction } from "../../../redux/contentUpload/contentUploadActions";
import useContentUpload from "../../../hooks/useContentUpload";
import SubjectsAutoComplete from "../../../components/Settings/Autocomplete/SubjectsAutoComplete";
import { fetchExamsAction } from "../../../redux/contentUpload/contentUploadActions";
import { PaperAutoComplete } from "../../../components/Settings/Autocomplete/PaperAutoComplete";
import {
  fetchGetStudent,
  fetchSchoolStudentPerformance,
} from "../../../redux/school/schoolActions";
import useSchool from "../../../hooks/useSchool";

const StudentPerformance = () => {
  const [selectedUser, setSelectedUser] = useState();
  const dispatch = useDispatch();
  const [values, setValues] = useState({ label: "", value: null });
  const [paperValues, setPaperValues] = useState({ label: "", value: null });
  const subscription = useSubscription();
  const { studyExam, examYearData, examTypeData, examData, loadingExam } =
    useContentUpload();
  const school = useSchool();
  const { userInfo, userPathByCategory } = useUser();
  const { allStudent, getStudentPerformance } = school;
  const schoolId = userInfo?.schoolId;
  const [showQuery, setShowQuery] = useState(false);
  const { allSubPlan, schoolSub, loading } = subscription;
  const [selectedSubject, setSelectedSubject] = useState();
  const [selectedPaper, setSelectedPaper] = useState();

  const handlePaper = (newValue) => {
    const paper = newValue?.examId;
    setSelectedPaper(paper);
  };

  const handleSubjects = (newValue) => {
    const subject = newValue?.subjectId;
    setSelectedSubject(subject);
    dispatch(fetchExamsAction(subject));
  };

  const handleStudent = (newValue) => {
    const student = newValue?.ProfileId;
    setSelectedUser(student);
    dispatch(fetchStudyExamByProfileId(student));
  };

  useEffect(() => {
    
     dispatch(fetchSchoolStudentPerformance(schoolId));
  }, []);


  const handleApplyFilter = () => {
    // debugger;
    if (selectedUser || selectedSubject || selectedPaper) {
     
      dispatch(
        fetchSchoolStudentPerformance(
          schoolId,
          selectedUser,
          selectedSubject,
          selectedPaper
        )
      );
    }
  };

  // function to remove theory and practical from the array
  const filteredUserCategory = examData?.filter(
    (item) =>
      !item?.examName?.includes("Theory") &&
      !item?.examName?.includes("Practical")
  );
  //function to get the name of the student
  const studentName = allStudent.find((names)=> names.ProfileId === selectedUser )?.FullName
  return (
    <>
      {loading && <BusyOverlay busy={loading} />}
      <Container sx={{ padding: { xs: "0px" } }}>
        <Box component={Stack} gap={3} padding={0} bgcolor={"#FAFAFB"}>
          <Box>
            <Typography color={"#45464E"} fontSize={"16px"} fontWeight={600}>
              Student Performance Reports
            </Typography>
            <Typography color={"#45464E"} fontSize={"14px"}>
              see the list of all studentss enrolled and their performance
              ratings
            </Typography>
          </Box>

          <Box
            display={"flex"}
            alignItems={"flex-start"}
            flexDirection={{ xs: "column", sm: "row", md: "column" }}
            sx={{
              borderRadius: 3,
              border: "1px solid #DFDFDF",
              height: "auto",
            }}
          >
            <Box
              p={2}
              pb={1}
              display={"flex"}
              alignItems={"start"}
              gap={3}
              justifyContent={"start"}
            >
              <Typography color={"#45464E"} fontSize={"14px"} fontWeight={600}>
                Filter by:
              </Typography>
            </Box>
            <Box
              alignItems={"flex-start"}
              flexDirection={{ xs: "column", sm: "row" }}
              display={"flex"}
              gap={3}
              pl={4}
              pb={2}
              mt={3}
            >
              <Autocomplete
                sx={{ width: 200 }}
                id="combo-box-demo"
                size="small"
                options={allStudent}
                value={selectedUser}
                onChange={(e, newValue) => {
                  handleStudent(newValue);
                }}
                getOptionLabel={(option) => {
                  return `${option.FullName}`;
                }}
                isOptionEqualToValue={(option, value) => {
                  // debugger;
                  return option.ProfileId === value.ProfileId;
                }} // Compare options based on ProfileId
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Student"
                    className="mb-1"
                    variant="outlined"
                  />
                )}
              />
              <Autocomplete
                sx={{ width: 200 }}
                id="combo-box-demo"
                size="small"
                options={studyExam}
                values={selectedSubject}
                onChange={(e, newValue) => {
                  handleSubjects(newValue);
                }}
                getOptionLabel={(option) => {
                  return `${option?.subjectName}`;
                }}
                isOptionEqualToValue={(option, value) => {
                  return option?.subjectId === value?.subjectId;
                }} // Compare options based on ProfileId
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subject"
                    className="mb-1"
                    variant="outlined"
                  />
                )}
              />
              <Autocomplete
                sx={{ width: 200, mr: 10 }}
                id="combo-box-demo"
                size="small"
                options={filteredUserCategory}
                values={values || ""}
                onChange={(e, newValue) => {
                  handlePaper(newValue);
                }}
                getOptionLabel={(option) => {
                  return `${option.examName}`;
                }}
                isOptionEqualToValue={(option, value) => {
                  return option.examId === value.examId;
                }} // Compare options based on ProfileId
                loading={loading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Paper"
                    className="mb-1"
                    variant="outlined"
                  />
                )}
              />
              {/* <Autocomplete
                sx={{ width: 200 }}
                id="combo-box-demo"
                size="small"
                  options={adminUsersData}
                  value={pagination.selectedUser}
                  onChange={(e, newValue) => {
                    handleUserAdmin(newValue);
                  }}
                  getOptionLabel={(option) => {
                    return `${option.FullName}`;
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return option.ProfileId === value;
                  }} // Compare options based on ProfileId
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grade"
                    className="mb-1"
                    variant="outlined"
                  />
                )}
              /> */}

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#40499D",
                  borderRadius: 2,
                  textTransform: "none",
                  
                  // position: "absolute",
                  color: "#FFFFFF",
                  "&:hover": {
                    backgroundColor: "#333a7d",
                  },
                }}
                onClick={handleApplyFilter}
                startIcon={<PlusIcon />}
              >
                Apply Filter
              </Button>
            </Box>
          </Box>

          <div className="mt-6 overflow-x-hidden">
            <PerformaceTable
              getStudentPerformance={getStudentPerformance}
              selectedUser={studentName}
              
             />
          </div>
        </Box>
      </Container>
    </>
  );
};

export default StudentPerformance;
